import drawEvent from './drawEvent'

export default (
  ctx,
  constants,
  cHeight,
  cWidth,
  yOffset,
  xOffset,
  hoveredEvent,
  shape,
) => {
  if (!hoveredEvent) {
    return
  }

  const { event, x: xPos, y: yPos } = hoveredEvent

  const x = xPos * constants.GRID_WIDTH
  const y = yPos * constants.GRID_HEIGHT

  ctx.fillStyle = 'rgba(0,0,0,0.1)'
  ctx.fillRect(
    x + constants.GRID_BORDER_WIDTH - xOffset,
    0,
    constants.GRID_WIDTH - constants.GRID_BORDER_WIDTH,
    cHeight,
  )
  ctx.fillRect(
    0,
    y + constants.GRID_BORDER_WIDTH - yOffset,
    cWidth,
    constants.GRID_HEIGHT - constants.GRID_BORDER_WIDTH,
  )

  const roundedHoveredX = Math.round(x - xOffset)
  const roundedHoveredY = Math.round(y - yOffset)
  const plusX =
    roundedHoveredX + (constants.GRID_WIDTH - constants.EVENT_GAP) / 2
  const plusY =
    roundedHoveredY + (constants.GRID_HEIGHT - constants.EVENT_HEIGHT) / 2
  if (!event) {
    drawEvent(
      ctx,
      constants,
      shape === 'diamond' ? plusX - constants.EVENT_DIAMOND_SLOPE / 2 : plusX,
      plusY,
      constants.GRID_WIDTH - constants.EVENT_GAP,
      constants.EVENT_HEIGHT,
      shape,
      null,
      null,
      null,
      true,
    )
  }
}
